import { Link } from 'react-router-dom';

interface ArticleCard {
  title: string;
  excerpt: string;
  imageUrl: string;
  linkTo: string;
  category: string;
  readTime: string;
}

interface SEOArticlesGridProps {
  title: string;
  subtitle?: string;
  articles: ArticleCard[];
}

export default function SEOArticlesGrid({ title, subtitle, articles }: SEOArticlesGridProps) {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-semibold text-accent-700 uppercase tracking-wider">SEO Guides</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-none mb-3">
            {title}
          </h2>
          {subtitle && (
            <p className="text-base text-foreground-500">{subtitle}</p>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article, i) => (
            <Link
              key={i}
              to={article.linkTo}
              onClick={handleClick}
              className="group block bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-accent-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-full h-[220px] md:h-[240px] overflow-hidden bg-background-100 relative">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium">
                    <i className="ri-book-read-line text-xs"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100 rounded-full px-3 py-1 mb-3">
                  {article.category}
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}